import { useState } from 'react';

const specialtiesList = [
  'Masaj Terapisi', 'Aromaterapi', 'Yüz Bakımı', 'Vücut Bakımı',
  'SPA Ritüelleri', 'Hamam Terapistliği', 'Refleksoloji', 'Lenf Drenaj',
  'Tay Masajı', 'Bali Masajı', 'Hot Stone', 'Sırt Masajı',
  'Anti-Stres', 'Detoks Programları', 'Spor Masajı'
];

const experienceYears = [
  { label: '0-1 yıl', value: '0-1' },
  { label: '1-3 yıl', value: '1-3' },
  { label: '3-5 yıl', value: '3-5' },
  { label: '5+ yıl', value: '5+' }
];

const workTypeList = ['Termal Otel', 'SPA Merkezi', 'Güzellik Salonu', 'Wellness Resort', 'Hamam', 'Hamam & SPA', 'Klinik', 'Özel Müşteri'];

interface WizardData {
  specialties: string[];
  experience: string;
  pastWorkTypes: string[];
  preferredWorkTypes: string[];
  preferredCities: string[];
  salaryBand: string;
  sgkPreference: string;
  accommodation: string;
  workModel: string;
  keseKopuk: string;
  bio: string;
  photoFile: string;
  idFile: string;
  certFile: string;
  visibilityMode: string;
}

const defaultData: WizardData = {
  specialties: [],
  experience: '',
  pastWorkTypes: [],
  preferredWorkTypes: [],
  preferredCities: [],
  salaryBand: '',
  sgkPreference: '',
  accommodation: '',
  workModel: '',
  keseKopuk: '',
  bio: '',
  photoFile: '',
  idFile: '',
  certFile: '',
  visibilityMode: ''
};

const cities = ['İstanbul', 'Antalya', 'Kayseri', 'Ankara', 'İzmir', 'Bursa', 'Adana', 'Mersin', 'Muğla', 'Trabzon'];
const salaryBands = ['45.000-60.000 TL', '60.000-70.000 TL', '70.000-90.000 TL', '90.000-120.000 TL'];
const sgkOptions = ['Zorunlu', 'Müzakereye Açığım', 'Fark Etmez'];
const accommodationOptions = ['İstiyorum', 'İstemiyorum'];
const workModels = ['Tam Zamanlı', 'Part-time', 'Sezonluk'];
const keseKopukOptions = ['Evet', 'Hayır', 'Müzakereye Açığım'];

const visibilityModes = [
  {
    value: 'active',
    title: 'Aktif İş Arıyorum',
    desc: 'Profiliniz uyumlu tüm spa işletmelerine görünür.',
    icon: 'ri-eye-line',
    highlight: false
  },
  {
    value: 'silent',
    title: 'Sessiz Kariyer',
    desc: 'Yalnızca yüksek uyumlu spa işletmelerine maskeli görünürsünüz.',
    icon: 'ri-moon-line',
    highlight: true
  },
  {
    value: 'not_available',
    title: 'Şu An Müsait Değilim',
    desc: 'Görünmezsiniz. CRM geçmişi korunur.',
    icon: 'ri-pause-circle-line',
    highlight: false
  },
  {
    value: 'hidden',
    title: 'Tam Gizli',
    desc: 'Aramalarda görünmezsiniz. CRM pasif kalır.',
    icon: 'ri-eye-off-line',
    highlight: false
  }
];

export default function ProfileWizard({ onComplete }: { onComplete: () => void }) {
  const [step, setStep] = useState(1);
  const [data, setData] = useState<WizardData>(defaultData);
  const [errors, setErrors] = useState<Record<string, string>>();

  const update = (partial: Partial<WizardData>) => setData((d) => ({ ...d, ...partial }));

  const toggleArray = (key: keyof WizardData, value: string) => {
    const arr = data[key] as string[];
    if (arr.includes(value)) {
      update({ [key]: arr.filter((v) => v !== value) } as Partial<WizardData>);
    } else {
      update({ [key]: [...arr, value] } as Partial<WizardData>);
    }
  };

  const validateStep = () => {
    const e: Record<string, string> = {};
    if (step === 1) {
      if (data.specialties.length === 0) e.specialties = 'En az bir uzmanlık seçin';
      if (!data.experience) e.experience = 'Deneyim süresi seçin';
    } else if (step === 2) {
      if (data.preferredCities.length === 0) e.preferredCities = 'En az bir şehir seçin';
      if (!data.salaryBand) e.salaryBand = 'Maaş beklentisi seçin';
      if (!data.sgkPreference) e.sgkPreference = 'SGK tercihi seçin';
      if (!data.accommodation) e.accommodation = 'Konaklama tercihi seçin';
      if (!data.workModel) e.workModel = 'Çalışma modeli seçin';
      if (!data.keseKopuk) e.keseKopuk = 'Kese & köpük tercihi seçin';
    } else if (step === 3) {
      if (!data.bio.trim()) e.bio = 'Mini bio yazın';
      else if (data.bio.length < 20) e.bio = 'Mini bio en az 20 karakter olmalıdır';
    } else if (step === 4) {
      if (!data.visibilityMode) e.visibilityMode = 'Görünürlük modu seçin';
    }
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const next = () => {
    if (validateStep()) {
      if (step < 4) setStep(step + 1);
      else onComplete();
    }
  };

  const prev = () => {
    if (step > 1) setStep(step - 1);
  };

  const progressWidth = `${(step / 4) * 100}%`;

  const handleFileChange = (key: keyof WizardData, e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      update({ [key]: e.target.files[0].name } as Partial<WizardData>);
    }
  };

  return (
    <div className="w-full max-w-2xl mx-auto">
      <div className="bg-white rounded-2xl border border-gray-100 shadow-soft p-6 md:p-10">
        {/* Progress */}
        <div className="mb-8">
          <div className="flex items-center justify-between mb-2">
            <span className="text-xs font-semibold text-deep-navy-400">Profil Tamamlama</span>
            <span className="text-xs font-medium text-dark-teal-500">Adım {step}/4</span>
          </div>
          <div className="w-full h-2 bg-off-white rounded-full overflow-hidden">
            <div
              className="h-full bg-dark-teal-500 rounded-full transition-all duration-300"
              style={{ width: progressWidth }}
            />
          </div>
          <div className="flex justify-between mt-2">
            {['Uzmanlık', 'Tercihler', 'Bio & Belgeler', 'Görünürlük'].map((label, i) => (
              <span
                key={label}
                className={`text-xs ${
                  i + 1 <= step ? 'text-dark-teal-500 font-medium' : 'text-gray-300'
                }`}
              >
                {label}
              </span>
            ))}
          </div>
        </div>

        {/* Step 1: Uzmanlık ve Deneyim */}
        {step === 1 && (
          <div className="space-y-6">
            <div>
              <h3 className="text-base font-bold text-deep-navy-500 mb-1">Uzmanlıklar</h3>
              <p className="text-xs text-gray-400 mb-3">Profilinize uygun tüm uzmanlıkları seçin</p>
              <div className="flex flex-wrap gap-2">
                {specialtiesList.map((s) => (
                  <button
                    key={s}
                    type="button"
                    onClick={() => toggleArray('specialties', s)}
                    className={`px-3 py-2 rounded-lg text-xs font-medium border transition-all cursor-pointer ${
                      data.specialties.includes(s)
                        ? 'border-dark-teal-500 bg-dark-teal-50 text-dark-teal-700'
                        : 'border-gray-200 text-gray-500 hover:border-gray-300'
                    }`}
                  >
                    {s}
                  </button>
                ))}
              </div>
              {errors.specialties && <p className="text-xs text-red-500 mt-2">{errors.specialties}</p>}
            </div>

            <div>
              <h3 className="text-base font-bold text-deep-navy-500 mb-3">Deneyim Süresi</h3>
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
                {experienceYears.map((ey) => (
                  <button
                    key={ey.value}
                    type="button"
                    onClick={() => update({ experience: ey.value })}
                    className={`py-3 rounded-xl text-sm font-medium border transition-all cursor-pointer ${
                      data.experience === ey.value
                        ? 'border-dark-teal-500 bg-dark-teal-50 text-dark-teal-600'
                        : 'border-gray-200 text-gray-500 hover:border-gray-300'
                    }`}
                  >
                    {ey.label}
                  </button>
                ))}
              </div>
              {errors.experience && <p className="text-xs text-red-500 mt-2">{errors.experience}</p>}
            </div>

            <div>
              <h3 className="text-base font-bold text-deep-navy-500 mb-1">Geçmiş Deneyim Alanları</h3>
              <p className="text-xs text-gray-400 mb-3">Daha önce çalıştığınız işletme tipleri (zorunlu değil)</p>
              <div className="flex flex-wrap gap-2">
                {workTypeList.map((t) => (
                  <button
                    key={t}
                    type="button"
                    onClick={() => toggleArray('pastWorkTypes', t)}
                    className={`px-3 py-2 rounded-lg text-xs font-medium border transition-all cursor-pointer ${
                      data.pastWorkTypes.includes(t)
                        ? 'border-dark-teal-500 bg-dark-teal-50 text-dark-teal-700'
                        : 'border-gray-200 text-gray-500 hover:border-gray-300'
                    }`}
                  >
                    {t}
                  </button>
                ))}
              </div>
            </div>

            <div>
              <h3 className="text-base font-bold text-deep-navy-500 mb-1">Tercih Ettiği Çalışma Alanları</h3>
              <p className="text-xs text-gray-400 mb-3">Çalışmak istediğiniz işletme tipleri (zorunlu değil)</p>
              <div className="flex flex-wrap gap-2">
                {workTypeList.map((t) => (
                  <button
                    key={t}
                    type="button"
                    onClick={() => toggleArray('preferredWorkTypes', t)}
                    className={`px-3 py-2 rounded-lg text-xs font-medium border transition-all cursor-pointer ${
                      data.preferredWorkTypes.includes(t)
                        ? 'border-dark-teal-500 bg-dark-teal-50 text-dark-teal-700'
                        : 'border-gray-200 text-gray-500 hover:border-gray-300'
                    }`}
                  >
                    {t}
                  </button>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* Step 2: Çalışma Tercihleri */}
        {step === 2 && (
          <div className="space-y-6">
            <div>
              <h3 className="text-base font-bold text-deep-navy-500 mb-3">Şehir Tercihleri</h3>
              <div className="flex flex-wrap gap-2">
                {cities.map((c) => (
                  <button
                    key={c}
                    type="button"
                    onClick={() => toggleArray('preferredCities', c)}
                    className={`px-3 py-2 rounded-lg text-xs font-medium border transition-all cursor-pointer ${
                      data.preferredCities.includes(c)
                        ? 'border-dark-teal-500 bg-dark-teal-50 text-dark-teal-700'
                        : 'border-gray-200 text-gray-500 hover:border-gray-300'
                    }`}
                  >
                    {c}
                  </button>
                ))}
              </div>
              {errors.preferredCities && <p className="text-xs text-red-500 mt-2">{errors.preferredCities}</p>}
            </div>

            <div>
              <h3 className="text-base font-bold text-deep-navy-500 mb-3">Maaş Beklenti Bandı</h3>
              <div className="grid grid-cols-2 gap-2">
                {salaryBands.map((sb) => (
                  <button
                    key={sb}
                    type="button"
                    onClick={() => update({ salaryBand: sb })}
                    className={`py-3 rounded-xl text-xs sm:text-sm font-medium border transition-all cursor-pointer ${
                      data.salaryBand === sb
                        ? 'border-dark-teal-500 bg-dark-teal-50 text-dark-teal-600'
                        : 'border-gray-200 text-gray-500 hover:border-gray-300'
                    }`}
                  >
                    {sb}
                  </button>
                ))}
              </div>
              {errors.salaryBand && <p className="text-xs text-red-500 mt-2">{errors.salaryBand}</p>}
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <h3 className="text-sm font-bold text-deep-navy-500 mb-2">SGK Tercihi</h3>
                <div className="space-y-2">
                  {sgkOptions.map((o) => (
                    <button
                      key={o}
                      type="button"
                      onClick={() => update({ sgkPreference: o })}
                      className={`w-full py-2.5 rounded-xl text-xs font-medium border transition-all text-left px-4 cursor-pointer ${
                        data.sgkPreference === o
                          ? 'border-dark-teal-500 bg-dark-teal-50 text-dark-teal-600'
                          : 'border-gray-200 text-gray-500 hover:border-gray-300'
                      }`}
                    >
                      {o}
                    </button>
                  ))}
                </div>
                {errors.sgkPreference && <p className="text-xs text-red-500 mt-1">{errors.sgkPreference}</p>}
              </div>

              <div>
                <h3 className="text-sm font-bold text-deep-navy-500 mb-2">Konaklama Tercihi</h3>
                <div className="space-y-2">
                  {accommodationOptions.map((o) => (
                    <button
                      key={o}
                      type="button"
                      onClick={() => update({ accommodation: o })}
                      className={`w-full py-2.5 rounded-xl text-xs font-medium border transition-all text-left px-4 cursor-pointer ${
                        data.accommodation === o
                          ? 'border-dark-teal-500 bg-dark-teal-50 text-dark-teal-600'
                          : 'border-gray-200 text-gray-500 hover:border-gray-300'
                      }`}
                    >
                      {o}
                    </button>
                  ))}
                </div>
                {errors.accommodation && <p className="text-xs text-red-500 mt-1">{errors.accommodation}</p>}
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <h3 className="text-sm font-bold text-deep-navy-500 mb-2">Çalışma Modeli</h3>
                <div className="space-y-2">
                  {workModels.map((m) => (
                    <button
                      key={m}
                      type="button"
                      onClick={() => update({ workModel: m })}
                      className={`w-full py-2.5 rounded-xl text-xs font-medium border transition-all text-left px-4 cursor-pointer ${
                        data.workModel === m
                          ? 'border-dark-teal-500 bg-dark-teal-50 text-dark-teal-600'
                          : 'border-gray-200 text-gray-500 hover:border-gray-300'
                      }`}
                    >
                      {m}
                    </button>
                  ))}
                </div>
                {errors.workModel && <p className="text-xs text-red-500 mt-1">{errors.workModel}</p>}
              </div>

              <div>
                <h3 className="text-sm font-bold text-deep-navy-500 mb-2">Kese & Köpük</h3>
                <div className="space-y-2">
                  {keseKopukOptions.map((o) => (
                    <button
                      key={o}
                      type="button"
                      onClick={() => update({ keseKopuk: o })}
                      className={`w-full py-2.5 rounded-xl text-xs font-medium border transition-all text-left px-4 cursor-pointer ${
                        data.keseKopuk === o
                          ? 'border-dark-teal-500 bg-dark-teal-50 text-dark-teal-600'
                          : 'border-gray-200 text-gray-500 hover:border-gray-300'
                      }`}
                    >
                      {o}
                    </button>
                  ))}
                </div>
                {errors.keseKopuk && <p className="text-xs text-red-500 mt-1">{errors.keseKopuk}</p>}
              </div>
            </div>
          </div>
        )}

        {/* Step 3: Mini Bio ve Belgeler */}
        {step === 3 && (
          <div className="space-y-6">
            <div>
              <h3 className="text-base font-bold text-deep-navy-500 mb-1">Mini Bio</h3>
              <p className="text-xs text-gray-400 mb-3">
                Kendinizi kısaca tanıtın. Yetenekleriniz, deneyiminiz ve yaklaşımınız.
              </p>
              <textarea
                value={data.bio}
                onChange={(e) => update({ bio: e.target.value })}
                maxLength={300}
                placeholder="Örn: 3 yıllık spa terapistiyim. Aromaterapi ve sırt masajında uzmanım. Misafir memnuniyeti odaklı çalışırım."
                rows={4}
                className="w-full px-4 py-3 rounded-xl border border-gray-200 text-sm text-deep-navy-500 placeholder:text-gray-300 focus:outline-none focus:border-dark-teal-300 transition-colors resize-none"
              />
              <div className="flex items-center justify-between mt-1">
                <p className="text-xs text-red-500">{errors.bio || ''}</p>
                <span className="text-xs text-gray-400">{data.bio.length}/300</span>
              </div>
              <div className="mt-2 p-3 rounded-lg bg-soft-gold-50 border border-soft-gold-200 flex items-start gap-2">
                <i className="ri-error-warning-line text-soft-gold-600 mt-0.5 text-sm" />
                <p className="text-xs text-soft-gold-700 leading-relaxed">
                  Mini bio içinde telefon, WhatsApp veya Instagram bilgisi yazılamaz. Bu tür içerikler moderasyon tarafından filtrelenecektir.
                </p>
              </div>
            </div>

            <div className="space-y-4">
              <h3 className="text-base font-bold text-deep-navy-500">Belgeler</h3>

              <div>
                <label className="block text-sm font-medium text-deep-navy-400 mb-2">
                  Profil Fotoğrafı <span className="text-gray-300 font-normal">(zorunlu değil)</span>
                </label>
                <div className="relative">
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => handleFileChange('photoFile', e)}
                    className="hidden"
                    id="photo-upload"
                  />
                  <label
                    htmlFor="photo-upload"
                    className="flex items-center gap-3 px-4 py-3 rounded-xl border border-gray-200 border-dashed cursor-pointer hover:border-dark-teal-300 transition-colors"
                  >
                    <i className="ri-image-line text-gray-400 text-lg" />
                    <span className="text-sm text-gray-500">
                      {data.photoFile || 'Fotoğraf seçin veya sürükleyin'}
                    </span>
                  </label>
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-deep-navy-400 mb-2">
                  Kimlik Belgesi <span className="text-gray-300 font-normal">(zorunlu değil)</span>
                </label>
                <div className="relative">
                  <input
                    type="file"
                    accept=".pdf,image/*"
                    onChange={(e) => handleFileChange('idFile', e)}
                    className="hidden"
                    id="id-upload"
                  />
                  <label
                    htmlFor="id-upload"
                    className="flex items-center gap-3 px-4 py-3 rounded-xl border border-gray-200 border-dashed cursor-pointer hover:border-dark-teal-300 transition-colors"
                  >
                    <i className="ri-file-upload-line text-gray-400 text-lg" />
                    <span className="text-sm text-gray-500">
                      {data.idFile || 'PDF veya resim dosyası yükleyin'}
                    </span>
                  </label>
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-deep-navy-400 mb-2">
                  Sertifika / Diploma <span className="text-gray-300 font-normal">(zorunlu değil)</span>
                </label>
                <div className="relative">
                  <input
                    type="file"
                    accept=".pdf,image/*"
                    onChange={(e) => handleFileChange('certFile', e)}
                    className="hidden"
                    id="cert-upload"
                  />
                  <label
                    htmlFor="cert-upload"
                    className="flex items-center gap-3 px-4 py-3 rounded-xl border border-gray-200 border-dashed cursor-pointer hover:border-dark-teal-300 transition-colors"
                  >
                    <i className="ri-award-line text-gray-400 text-lg" />
                    <span className="text-sm text-gray-500">
                      {data.certFile || 'Sertifika veya diploma yükleyin'}
                    </span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Step 4: Görünürlük Modu */}
        {step === 4 && (
          <div className="space-y-6">
            <div>
              <h3 className="text-base font-bold text-deep-navy-500 mb-1">Görünürlük Modu Seçin</h3>
              <p className="text-xs text-gray-400 mb-4">
                Profilinizin nasıl görüneceğini ve kime ulaşacağını kontrol edin.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {visibilityModes.map((mode) => (
                <button
                  key={mode.value}
                  type="button"
                  onClick={() => update({ visibilityMode: mode.value })}
                  className={`relative p-4 rounded-xl border text-left transition-all cursor-pointer ${
                    mode.highlight
                      ? data.visibilityMode === mode.value
                        ? 'border-dark-teal-500 bg-dark-teal-50'
                        : 'border-dark-teal-200 bg-dark-teal-50/50 hover:border-dark-teal-300'
                      : data.visibilityMode === mode.value
                      ? 'border-dark-teal-500 bg-dark-teal-50'
                      : 'border-gray-200 hover:border-gray-300'
                  }`}
                >
                  {mode.highlight && (
                    <span className="absolute top-3 right-3 px-2 py-0.5 bg-dark-teal-500 text-white text-[10px] font-semibold rounded-full">
                      Önerilen
                    </span>
                  )}
                  <i className={`${mode.icon} text-lg ${
                    mode.highlight ? 'text-dark-teal-500' : 'text-gray-400'
                  } mb-2 block`} />
                  <h4 className="text-sm font-bold text-deep-navy-500 mb-1">{mode.title}</h4>
                  <p className="text-xs text-gray-500 leading-relaxed">{mode.desc}</p>
                </button>
              ))}
            </div>
            {errors.visibilityMode && <p className="text-xs text-red-500">{errors.visibilityMode}</p>}

            {data.visibilityMode === 'silent' && (
              <div className="p-4 rounded-xl bg-dark-teal-50 border border-dark-teal-200">
                <div className="flex items-start gap-3">
                  <i className="ri-moon-line text-dark-teal-500 text-lg mt-0.5" />
                  <div>
                    <h4 className="text-sm font-bold text-dark-teal-700 mb-1">Sessiz Kariyer Modu</h4>
                    <p className="text-xs text-dark-teal-600 leading-relaxed">
                      Yeni fırsatlara açık olun ama herkes tarafından görünmeyin. İsim, fotoğraf ve iletişim bilgileriniz gizli kalır; yalnızca yüksek uyumlu işletmelere kontrollü şekilde gösterilirsiniz.
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        {/* Actions */}
        <div className="flex items-center justify-between mt-8 pt-4 border-t border-gray-100">
          <button
            onClick={prev}
            disabled={step === 1}
            className={`px-6 py-2.5 rounded-full text-sm font-medium transition-colors cursor-pointer ${
              step === 1
                ? 'text-gray-300 cursor-default'
                : 'text-deep-navy-400 hover:bg-off-white'
            }`}
          >
            Geri
          </button>
          <button
            onClick={next}
            className="px-8 py-3 rounded-full text-sm font-semibold text-white bg-dark-teal-500 hover:bg-dark-teal-600 transition-colors cursor-pointer"
          >
            {step === 4 ? 'Profilimi Tamamla' : 'Devam Et'}
          </button>
        </div>
      </div>
    </div>
  );
}